import React from 'react';
import { withStyles } from '@mui/styles';

import TrplForm from './TrplForm';
import TrplFormFullScreenDialog from './TrplFormFullScreenDialog';

import styles from '../CommonStyles';

class NestedTrplFormDialog extends React.Component {
  render() {
    const {
      jels,
      classes,
      createNodeCb,
      initialNodeId,
      initialViewId,
      objEditModalData,
      onSaveTrplsClick,
      closeObjectEditModal,
    } = this.props;

    const objectEditModalTitle = `${objEditModalData.form ? `${objEditModalData.form.title}` : ''}`;

    const formId = objEditModalData.form ? objEditModalData.form.id : null;

    return (
      <TrplFormFullScreenDialog
        isOpen={objEditModalData.isOpened}
        paperFullScreenStyles={classes.trplFormPaper}
      >
        <div className={classes.pb120}>
          <TrplForm
            formId={formId}
            title={objectEditModalTitle}
            mode={objEditModalData.type}
            createNodeCb={createNodeCb}
            saveModal={onSaveTrplsClick}
            initialNodeId={initialNodeId}
            initialViewId={initialViewId}
            iId={objEditModalData.ancestor}
            closeModal={closeObjectEditModal}
            formConceptId={formId && jels.jelData[formId].concept}
            groups={objEditModalData.form ? objEditModalData.form.groups : []}
            tabs={objEditModalData.form && objEditModalData.form.tabsTitles ? objEditModalData.form.tabsTitles : []}
          />
        </div>
      </TrplFormFullScreenDialog>
    );
  }
}

export default withStyles(styles)(NestedTrplFormDialog);
